
import { importSync as i, macroCondition, getGlobalConfig } from '@embroider/macros';
let w = window;
let d = w.define;


i("./-embroider-implicit-modules.js");

d("docs-app/app", function(){ return i("docs-app/app.ts");});
d("docs-app/config/environment", function(){ return i("docs-app/config/environment.js");});
d("docs-app/docs-support/index", function(){ return i("docs-app/docs-support/index.ts");});
d("docs-app/docs-support/renderer", function(){ return i("docs-app/docs-support/renderer.ts");});
d("docs-app/docs-support/signature/component", function(){ return i("docs-app/docs-support/signature/component.ts");});
d("docs-app/docs-support/utils", function(){ return i("docs-app/docs-support/utils.ts");});
d("docs-app/markdown/compiler", function(){ return i("docs-app/markdown/compiler.ts");});
d("docs-app/markdown/import-map", function(){ return i("docs-app/markdown/import-map.ts");});
d("docs-app/markdown/index", function(){ return i("docs-app/markdown/index.ts");});
d("docs-app/router", function(){ return i("docs-app/router.ts");});
d("docs-app/services/docs", function(){ return i("docs-app/services/docs.ts");});
d("docs-app/services/selected", function(){ return i("docs-app/services/selected.ts");});
d("docs-app/services/types", function(){ return i("docs-app/services/types.ts");});
d("docs-app/services/ui", function(){ return i("docs-app/services/ui.ts");});
d("docs-app/services/page-title", function(){ return i("docs-app/services/page-title.js");});
d("docs-app/component-managers/glimmer", function(){ return i("docs-app/component-managers/glimmer.js");});
d("docs-app/initializers/app-version", function(){ return i("docs-app/initializers/app-version.js");});
d("docs-app/container-debug-adapter", function(){ return i("docs-app/container-debug-adapter.js");});
d("docs-app/services/-ensure-registered", function(){ return i("docs-app/services/-ensure-registered.js");});
d("docs-app/routes/index", function(){ return i("docs-app/routes/index.ts");});
d("docs-app/templates/application", function(){ return i("docs-app/templates/application.ts");});





if (!runningTests) {
  i("../app").default.create({"name":"docs-app","version":"0.0.0+a75a8cd5"});
}

